import { takeEvery, all, select, put } from 'redux-saga/effects';
import * as actions from './actions.js';

import * as auth from '../auth';
import * as router from '../router';
import firestoreRedux from '@dreamworld/firestore-redux';

import * as utils from '../../utils';

/**
 * Load account invitation quota from Firestore
 */
function* loadQuota({ accountId, requesterId }) {
  const state = yield select();
  const userId = auth.selectors.currentUserId(state);
  const accessibleAccounts = auth.selectors.accessibleAccounts(state);
  accountId = accountId || router.selectors.accountId(state);

  if (!userId || !accountId) {
    console.error('Failed to load account invitation quota: Missing userId or accountId');
    return;
  }

  if (!accessibleAccounts || !accessibleAccounts.includes(accountId)) {
    console.error('Failed to load account invitation quota: User does not have access to account', { accountId, userId });
    return;
  }

  try {
    const queryId = requesterId || `account-invitation-quota-${accountId}`;
    const docId = `aiq_${utils.getIdWoPrefix({ id: accountId, prefix: 'acc_' })}`;
    const collectionPath = `accounts/${accountId}/account-invitation-quota`;
    
    // Get the specific document for this account
    const query = firestoreRedux.getDocById(collectionPath, docId, { requesterId: queryId });
    const doc = yield query.result;
    console.log('Loaded account invitation quota:', doc);
    yield put(actions._loadQuotaSuccess({ accountId, data: doc }));
  } catch (error) {
    yield put(actions._loadQuotaFailed({ accountId, error: error?.code || 'UNKNOWN' }));
    console.error('Failed to load account invitation quota due to:', error);
  }
}

/**
 * Disconnect from Firestore listener
 */
function* disconnect({ accountId, requesterId }) {
  const state = yield select();
  const userId = auth.selectors.currentUserId(state);
  accountId = accountId || router.selectors.accountId(state);

  if (userId && accountId) {
    const queryId = requesterId || `account-invitation-quota-${accountId}`;
    firestoreRedux.cancelQueryByRequester(queryId);
  }
}

/**
 * Root saga
 */
export default function* accountInvitationQuotaSaga() {
  yield all([
    takeEvery(actions.LOAD_QUOTA, loadQuota),
    takeEvery(actions.DISCONNECT, disconnect)
  ]);
}
